<script setup lang="ts">
import { PhWarningCircle } from '@phosphor-icons/vue';
import { useI18n } from 'vue-i18n';
import { FileManagerNotice } from '../../../../sub-components/notice';
import { useFileManagerNavigation } from '../../../../logic/core/useFileManagerNavigation';

const { t } = useI18n();
const { navigateTo } = useFileManagerNavigation();
// Back to the virtual root, whatever the root happens to list — the project's two libraries on the
// project page, every provisioned project on the admin page. Hence the neutral wording.
const goToRoot = () => navigateTo('/', { replace: true });
</script>

<template>
  <FileManagerNotice
    :icon="PhWarningCircle"
    :heading="t('fileManager.fileExplorerView.errorHeading')"
    :message="t('fileManager.fileExplorerView.errorDescription')"
  >
    <button type="button" class="button is-primary" @click="goToRoot">
      {{ t('fileManager.fileExplorerView.errorBackToRootButton') }}
    </button>
  </FileManagerNotice>
</template>

<style scoped>
/* Slot content is scoped to this component, not to FileManagerNotice — the notice stays free of
   knowledge about what callers put in its slot. */
.button {
  margin-top: 0.75rem;
}
</style>
